import React, { useCallback, useEffect, useLayoutEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

// import { getUserDomainCompanyImages } from '@/store/users/actions';
import { getLanguagesFiltered } from '@/store/locales/actions';
import { getSearch } from '@/store/search/actions';
import {
  changeTopicFilter /*getTopicCategories, */,
  clearTopicFilter,
  getTopicLevel,
  getTopics,
  getTopicTypes,
} from '@/store/topics/actions';

import { selectLocales } from '@/store/locales/selectors';
import { selectSearchUnion } from '@/store/search/selectors';
import { selectTopics, selectTopicsCategoriesUnion } from '@/store/topics/selectors';
import { selectUsers } from '@/store/users/selectors';

import { Layout, Pagination, Typography } from 'antd';
import css from '@/pages/CollectionMaterials/CollectionMaterials.module.scss';
import DialogFilterSelectCompetence from '@/pages/CollectionMaterials/DialogFilterSelectCompetence';
import ContextSearch from '@/components/ContextSearch';
import TopicCards from '@/components/TopicCards';

import TopicFilter from '../TopicFilter';

import Sort from '@shared/components/NewSort';
import { SortTypeHelp } from '@shared/components/NewSort/constants';
import { parseAllSearchParams } from '@shared/utils/get-query-string';

import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import _debounce from 'lodash/debounce';
import PropTypes from 'prop-types';

import { FILTER_TYPE_COURSES, FILTER_TYPE_EVENTS } from '@/constants/file-types';

dayjs.extend(isBetween);

const { Content } = Layout;
const { Title } = Typography;

const initialTopicsParams = {
  size: 19,
  page: 1,
  search: '',
  searchName: '',
  skillIds: '',
  sort: 'positions.position,asc&sort=createdDate,desc&sort=id,asc',
  hasEvent: '',
  actual: '',
  startDate: '',
  endDate: '',
};

const initialSearchTopics = {
  authorName: '',
  publisher: '',
  tagName: '',
  skillName: '',
  name: '',
  searchResult: '',
  tagId: '',
  authorId: '',
  skillId: '',
};

const initialTopicFilters = {
  topicTypeId: '',
  typeId: undefined,
  topicLevelId: undefined,
  topicCategoryName: undefined,
  languageId: undefined,
  free: '',
  hasBlock: '',
  topicSubTypeId: '',
};

const initialAllState = {
  ...initialTopicsParams,
  ...initialSearchTopics,
  ...initialTopicFilters,
};

let controllerTopics = null;

const CollectionMaterials = props => {
  const { t } = useTranslation('collectionMaterials');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { topics, level, types, isLoadingTopicsCatalog, topicsTotal, topicFilter, topicsPageNumber } =
    useSelector(selectTopics);

  const searchResults = useSelector(selectSearchUnion);
  const topicCategories = useSelector(selectTopicsCategoriesUnion);
  const { currentUser } = useSelector(selectUsers);
  const { languagesFiltered } = useSelector(selectLocales);

  const searchTypes = [
    { id: '', type: 'searchResult', searchType: 'searchResult', tagType: 'searchResult', name: t('all') },
    { id: 1, type: 'name', searchType: 'TOPIC', tagType: 'name', name: t('selectName') },
    { id: 2, type: 'authorName', searchType: 'AUTHOR', tagType: 'authorId', name: t('selectAuthor') },
    { id: 3, type: 'publisher', searchType: 'PUBLISHER', tagType: 'publisher', name: t('selectCompany') },
    { id: 4, type: 'tagName', searchType: 'TAG', tagType: 'tagId', name: t('selectTag') },
    { id: 5, type: 'skillName', searchType: 'SKILL', tagType: 'skillId', name: t('selectSkill') },
  ];

  const searchTypesTypes = searchTypes.map(item => item.type);

  const [state, setState] = useState({
    searchingTopics: false,
    global: currentUser?.domainCompany?.global,
    currentTopicId: 0,
    listAllCompetence: [],
    competencesAndCategoriesQuantity: {},
    skillsNames: null,
    restoreFirstRequest: props.location.state?.comeFromHeader,
  });
  const [openDialogFilterSelectCompetence, setOpenDialogFilterSelectCompetence] = useState(false);

  const initialQuerySearchParams = useMemo(() => parseAllSearchParams(document.location.search), []);

  const [queryParams, setQueryParams] = useState(initialQuerySearchParams);
  const [searchParams, setSearchParams] = useSearchParams(initialQuerySearchParams);

  const [selectedItemId, setSelectedItemId] = useState(0);

  const [topicsParams, setTopicsParams] = useState({
    ...initialAllState,
    ...initialQuerySearchParams,
    ...topicFilter,
    // данное решение временное, так как в searchParams нельза записать skillIds, а в таком формате принимает сам запрос, данное переопеределение нужно не только для того чтобы в запрос отправлялось корректный ключ, но и убрать задвоение skillids
    skillIds: initialQuerySearchParams.skillids,
    skillids: undefined,
  });

  const getSearchDebounced = useCallback(
    _debounce((...args) => {
      dispatch(getSearch(...args));
    }, 400),
    []
  );

  const handleFilterChange = event => {
    setTopicsParams(prevTopicsParams => ({ ...prevTopicsParams, ...event, page: 1 }));

    const filtersToSave = [
      'topicTypeLabelId',
      'typeId',
      'topicSubTypeId',
      'topicCategoryName',
      'topicLevelId',
      'languageId',
      // далее все типы для строки поиска
      ...searchTypesTypes,
    ];

    Object.entries(event).forEach(([key, value]) => {
      if (filtersToSave.includes(key) && value !== undefined) {
        dispatch(changeTopicFilter(key, value));
      }
    });
  };

  const handleFilterClear = () => {
    const { topicCategoryName, topicLevelId, languageId, typeId, skillIds } = topicsParams;
    if (!topicCategoryName && !topicLevelId && !languageId && !typeId && !skillIds) {
      return;
    }
    setTopicsParams(initialAllState);
    dispatch(clearTopicFilter());
    setState({ ...state, competencesAndCategoriesQuantity: {} });
  };

  const changePage = page => {
    window.scrollTo(0, 0);
    setTopicsParams({ ...topicsParams, page });
  };

  const handleChangeSort = sort => {
    setTopicsParams({ ...topicsParams, sort, page: 1, typeId: topicsParams?.typeId });
  };

  const onSearchChange = (value, type) => {
    getSearchDebounced(value, type === 'searchResult' ? '' : type, 'topic');
  };

  const onSearchSubmit = ({ type, value }) => {
    setTopicsParams(prevParams => {
      const updParams = { ...prevParams, ...initialSearchTopics, [type]: value, type };
      const prevType = prevParams.type;

      if (prevType && prevType !== type) {
        delete updParams[prevType];
        dispatch(changeTopicFilter(prevType, undefined));
      }

      dispatch(changeTopicFilter(type, value));
      dispatch(changeTopicFilter('type', type));

      delete updParams.page;
      return updParams;
    });
  };

  const onSearchSuggestClick = (itemId, value, type) => {
    if (!type || type === 'name' || type === 'searchResult') {
      setSelectedItemId(itemId);
    } else {
      setTopicsParams({
        ...topicsParams,
        ...initialSearchTopics,
        searchResult: value,
        [type]: type === 'publisher' ? value : itemId,
      });
    }
  };

  const handleSortReset = () => {
    setTopicsParams({ ...topicsParams, sort: initialTopicsParams.sort });
  };

  const getNearestFilterObject = () => {
    switch (topicsParams?.typeId) {
      case FILTER_TYPE_COURSES:
        return [{ name: t('nearest'), value: ['nearEvent,asc', 'nearEvent,desc'] }];
      case FILTER_TYPE_EVENTS:
        return [{ name: t('nearest'), value: ['state,asc&sort=start,asc', 'state,desc&sort=start,desc'] }];
      default:
        break;
    }

    return [];
  };

  const closeModalSelectCompetence = () => {
    setOpenDialogFilterSelectCompetence(false);
  };

  const setDataFromModalSelectCompetence = (list, skillsNames) => {
    setState({ ...state, skillsNames });
    closeModalSelectCompetence();
    setTopicsParams({ ...topicsParams, skillIds: list });
  };

  const setListAllCompetence = listAllCompetence => {
    setState({ ...state, listAllCompetence });
  };

  useEffect(() => {
    if (topicsPageNumber) setTopicsParams({ ...topicsParams, page: topicsPageNumber + 1 });
  }, []);

  useEffect(() => {
    if (!location.search) {
      setTopicsParams({ ...initialAllState, ...topicFilter });
    } else {
      const currentParams = parseAllSearchParams(location.search);
      setTopicsParams({ ...topicsParams, ...currentParams });
    }
  }, [location.search]);

  useEffect(() => {
    if (selectedItemId) {
      navigate(`/collection-topics/${selectedItemId}`);
    }
  }, [selectedItemId]);

  useEffect(() => {
    if (controllerTopics) controllerTopics.abort();
    controllerTopics = new AbortController();

    dispatch(getTopics(topicsParams, () => {}, controllerTopics.signal));
  }, [topicsParams]);

  useLayoutEffect(() => {
    // dispatch(getUserDomainCompanyImages()); Нужен рефакторинг
    if (languagesFiltered?.length === 0) dispatch(getLanguagesFiltered());
    if (!types) dispatch(getTopicTypes());
    if (!level) dispatch(getTopicLevel());
    // в компоненте ModalFlower дергается эта ручка getTopicCategories закомментировал чтоб не дублировался код
    // if (!topics) dispatch(getTopicCategories(currentUser?.domainCompany?.global));
    // return () => dispatch(clearTopics());
  }, []);

  const isActiveFilterSkillIds = Boolean(
    topicsParams.skillIds && Array.isArray(topicsParams.skillIds) && topicsParams.skillIds.length > 0
  );

  const isFilterNotEmpty =
    topicsParams &&
    (topicsParams.name ||
      topicsParams.authorName ||
      topicsParams.publisher ||
      topicsParams.tagName ||
      topicsParams.authorId ||
      topicsParams.tagId ||
      topicsParams.skillId ||
      isActiveFilterSkillIds ||
      topicsParams.skillName ||
      topicsParams.searchResult);

  const showStartSearch = topicsParams.typeId === 1 || topicsParams.typeId === 2;

  const sortTypes = [
    {
      name: t('popularity'),
      value: [
        'positions.position,asc&sort=topicShortTermPopularities.shortTermPopularity,desc&sort=id,asc',
        'positions.position,desc&sort=topicShortTermPopularities.shortTermPopularity,asc&sort=id,desc',
      ],
      type: SortTypeHelp.COUNT,
    },
    {
      name: t('rating'),
      value: ['rates.rate,asc&sort=id,desc', 'rates.rate,desc&sort=id,asc'],
      type: SortTypeHelp.COUNT,
    },
    ...(showStartSearch ? getNearestFilterObject() : []),
    {
      name: t('date'),
      value: [
        'positions.position,asc&sort=createdDate,desc&sort=id,asc',
        'positions.position,desc&sort=createdDate,asc&sort=id,desc',
      ],
      type: SortTypeHelp.DATE,
    },
  ];

  const labelActualSearchType = topicsParams?.searchResult || '';

  const labelSearchText =
    labelActualSearchType.length > 20 ? `${labelActualSearchType.substring(0, 20)}... ` : labelActualSearchType;

  const isXmas = () => {
    const endOfYear = dayjs().set('month', 11).set('date', 10); // 10.12
    const newYear = endOfYear.add(1, 'month');

    return dayjs().isBetween(endOfYear, newYear, null, '[]'); // '[]' означает включительно
  };

  useEffect(() => {
    const searchParamsStringify = searchParams.toString();

    setQueryParams({ ...parseAllSearchParams(searchParamsStringify) });
  }, [searchParams]);

  useEffect(() => {
    const updateKeys = Object.keys(topicFilter).reduce((acc, key) => {
      if ((searchTypesTypes.includes(key) || key === 'type') && topicFilter[key]) {
        acc[key] = topicFilter[key];
      }
      return acc;
    }, {});

    if (Object.keys(updateKeys).length > 0) {
      setSearchParams({ ...updateKeys });
    }
  }, [topicFilter]);

  return (
    <Content className={css['App-content']}>
      <div className={css['CollectionMaterials-header-row']}>
        <div className={css['CollectionMaterials-header-text']}>
          <Title data-qa='userCollectionTopicH1' level={1}>
            {t('collection')}
          </Title>
        </div>

        <div className={css['MyCollection-header-search']}>
          <ContextSearch
            dataQa='collectionTopicSearch'
            navigate={navigate}
            onChange={onSearchChange}
            onSearchSubmit={onSearchSubmit}
            onSearchSuggestClick={onSearchSuggestClick}
            queryParams={queryParams}
            searchResults={searchResults}
            searchTypes={searchTypes}
            isFiltered={isFilterNotEmpty}
            initialQuerySearchParams={initialQuerySearchParams}
            type={topicsParams.type}
          />
        </div>
      </div>
      <TopicFilter
        filter={topicsParams}
        competencesAndCategoriesQuantity={args => setState({ ...state, competencesAndCategoriesQuantity: args })}
        topicTypes={types}
        topicCategories={topicCategories}
        topicLevel={level}
        onChange={handleFilterChange}
        onClear={handleFilterClear}
        onSortReset={handleSortReset}
        domainCompany={currentUser.domainCompany}
        currentUser={currentUser}
        myCollection={false}
        topicLanguages={languagesFiltered}
        openModalSelectCompetence={() => setOpenDialogFilterSelectCompetence(true)}
        showAllCategory
      />
      {/* <div className={css['CollectionMaterials-sort-block-sortBy']}>{t('sortBy')}</div> */}
      {topics?.length > 0 && (
        <Sort
          activeSort={topicsParams.sort}
          isLoading={isLoadingTopicsCatalog}
          handleChangeSort={handleChangeSort}
          sortTypes={sortTypes}
          className={css['CollectionMaterials-sort-block']}
        />
      )}

      <TopicCards
        isLoading={isLoadingTopicsCatalog}
        topics={topics}
        isAddMaterialButton
        isFilterNotEmpty={isFilterNotEmpty}
        searchText={topicsParams.searchResult}
        xmas={isXmas()}
      />

      {!isLoadingTopicsCatalog && topics?.length > 0 && (
        <Pagination
          current={topicsParams.page}
          total={topicsTotal}
          pageSize={initialTopicsParams.size}
          onChange={changePage}
          showSizeChanger={false}
          className={css['CollectionMaterials-pagination']}
          responsive
          hideOnSinglePage
        />
      )}

      <DialogFilterSelectCompetence
        filter={topicsParams}
        setCompetencesAndCategoriesQuantity={args => setState({ ...state, competencesAndCategoriesQuantity: args })}
        open={openDialogFilterSelectCompetence}
        onCancel={closeModalSelectCompetence}
        onSetSearch={setDataFromModalSelectCompetence}
        onSetListAllCompetence={setListAllCompetence}
        referenceCheckedKeys={state.competencesAndCategoriesQuantity} //Решил костылём сброс выбранных компетенций
      />
    </Content>
  );
};

CollectionMaterials.propTypes = {
  isLoadingTopicsCatalog: PropTypes.bool,
  topics: PropTypes.array,
  topicsTotal: PropTypes.number,
};

export default CollectionMaterials;
